<template>
  <div class="frame-page h-full !m-0px p-20px flex flex-column">
    <Tabs class="bg-white-color px-16px" :datas="{AccountSummary:'按账户汇总',IoSummary:'按收支类别汇总',customerSummary:'按客户汇总',vendorSummary:'按供应商汇总',employeeSummary:'按员工汇总',projectSummary:'按项目汇总',departmentSummary:'按部门汇总'}" v-model="tab"/>
    <component :is="tab"/>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */

import AccountSummary from "@/views/cashier/reprot/AccountSummary";
import IoSummary from "@/views/cashier/reprot/IoSummary";
import customerSummary from "@/views/cashier/reprot/customerSummary";//jxdadd
import vendorSummary from "@/views/cashier/reprot/vendorSummary";//jxdadd
import employeeSummary from "@/views/cashier/reprot/employeeSummary";//jxdadd
import projectSummary from "@/views/cashier/reprot/projectSummary";//jxdadd
import departmentSummary from "@/views/cashier/reprot/departmentSummary";//jxdadd

export default {
  name: "FundsReport",
  components: {
    AccountSummary,
    IoSummary,
    customerSummary,//jxdadd
    vendorSummary,//jxdadd
    employeeSummary,//jxdadd
    projectSummary,//jxdadd
    departmentSummary,//jxdadd
  },
}
</script>

<script setup>
import {ref} from "vue";

const tab = ref('AccountSummary')
</script>
